import { auth } from './auth';
import { customers } from './customers';
import { jobs, lineItems } from './jobs';
import { products } from './products';
import { scheduling } from './scheduling';
import { settings } from './settings';
import { users } from './users';

export { apiClient, baseURL, extractApiError, getCookie, refreshPromise, sanitiseApiError } from './client';
export { auth } from './auth';
export type { LoginResponse, RefreshResponse, SwitchOrgResponse } from './auth';
export { customers } from './customers';
export { jobs, lineItems } from './jobs';
export type { LineItemInput } from './jobs';
export { products } from './products';
export { scheduling } from './scheduling';
export { settings } from './settings';
export { users } from './users';
export type {
  AvailableTechnician,
  CreateJobPayload,
  Customer,
  CustomersListParams,
  CustomersListResponse,
  DraftLineItem,
  InviteStatus,
  Job,
  JobLineItem,
  JobsListParams,
  JobsListResponse,
  JobState,
  LineItemDisplayItem,
  LineItemFormInput,
  LineItemsResponse,
  LineItemTotals,
  NoteEntry,
  Organization,
  OrgSettings,
  OrgSettingsInput,
  OrgUser,
  Product,
  ProductInput,
  Schedule,
  SchedulePayload,
  TenantContext,
  User,
} from '../types';

export const org = {
  ...settings,
  ...users,
};

const api = {
  auth,
  customers,
  jobs,
  lineItems,
  org,
  products,
  scheduling,
};

export default api;
